import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerActions } from './+state/error-handler.actions';

export const errorHandlingInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  return next(request).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        store.dispatch(ErrorHandlerActions.throwError({ error }));
      }

      return throwError(() => error);
    })
  );
};
